'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/operators/numeric', null, {
            me: {method: 'GET'},
        });
    }];